import branditRails from '../../../../api/brandit_rails'
import {
  clearIntegrationsErrorsAction,
  setIntegrationsErrorsAction,
  setIntegrationsDataAction,
  setIntegrationsModeAction,
  setIntegrationsStatusAction
} from './integrations.actions'

/**
 * Fetch portal core integrations
 * @returns {(dispatch: import('redux').Dispatch) => Promise<void>}
 */
export const fetchIntegrations = ({ mode }) => async dispatch => {
  try {
    dispatch(setIntegrationsStatusAction('loading'))
    dispatch(clearIntegrationsErrorsAction())
    dispatch(setIntegrationsModeAction(mode))

    const { data } = await branditRails.get('/integrations', { params: { mode } })

    dispatch(setIntegrationsDataAction(data))
    dispatch(setIntegrationsStatusAction('succeeded'))
  } catch (err) {
    dispatch(setIntegrationsStatusAction('failed'))
    dispatch(
      setIntegrationsErrorsAction({
        action: 'fetchIntegrations',
        message: err.message || err.response?.data?.message || 'Failed to fetch integrations'
      })
    )
  }
}
